/**
 * Fechas de un modelo, tal y como se muestran en sus tarjetas.
 *
 * `created_at` y `modified_at` los sirve el backend en ISO 8601. Se muestran en
 * relativo ("hace 3 días") porque en un listado lo que se quiere saber es qué
 * se tocó hace poco, no el día exacto; la fecha completa va en el `title` para
 * quien la necesite.
 */

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatAbsolute(value) {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
    });
}

/** "hace 5 min" / "hace 3 días" / "12 mar 2026" a partir de un mes. */
export function formatRelative(value) {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;

    const elapsed = Date.now() - date.getTime();
    if (elapsed < 0) return formatAbsolute(value);
    if (elapsed < MINUTE) return 'hace un momento';
    if (elapsed < HOUR) return `hace ${Math.floor(elapsed / MINUTE)} min`;
    if (elapsed < DAY) {
        const hours = Math.floor(elapsed / HOUR);
        return `hace ${hours} ${hours === 1 ? 'hora' : 'horas'}`;
    }
    if (elapsed < 30 * DAY) {
        const days = Math.floor(elapsed / DAY);
        return `hace ${days} ${days === 1 ? 'día' : 'días'}`;
    }
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * Pie de tarjeta acorde al criterio de ordenación activo.
 *
 * Al ordenar por creación se enseña la fecha de creación, y en cualquier otro
 * caso la de edición, que es la que más dice de un modelo en uso. Devuelve null
 * si el backend no mandó la fecha, para no pintar un hueco vacío.
 */
export function dateCaption(modelo, sortBy) {
    if (sortBy === 'created_at') {
        const created = formatRelative(modelo?.created_at);
        return created ? `Creado ${created}` : null;
    }
    const modified = formatRelative(modelo?.modified_at);
    return modified ? `Editado ${modified}` : null;
}
